import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui'
import { Card, CardContent, CardHeader, CardFooter } from '../ui/card'
import React from 'react'

export function SkeletonTable() {
  return (
    <div className="space-y-4">
      <div className="rounded-md">
        <Table>
          <TableHeader>
            <TableRow className="h-[60px]">
              <TableHead className="w-[100px]">
                <div className="h-4 bg-gray-300 rounded animate-pulse" />
              </TableHead>
              <TableHead>
                <div className="h-4 bg-gray-300 rounded animate-pulse" />
              </TableHead>
              <TableHead>
                <div className="h-4 bg-gray-300 rounded animate-pulse" />
              </TableHead>
              <TableHead>
                <div className="h-4 bg-gray-300 rounded animate-pulse" />
              </TableHead>
              <TableHead>
                <div className="h-4 bg-gray-300 rounded animate-pulse" />
              </TableHead>
              <TableHead className="w-[100px]"></TableHead>
              <TableHead className="w-[100px]"></TableHead>
              <TableHead className="w-[100px]"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: 5 }).map((_, index) => (
              <TableRow key={index} className="h-[60px]">
                <TableCell className="text-sm">
                  <div className="h-4 bg-gray-300 rounded animate-pulse" />
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <div className="h-6 w-6 bg-gray-300 rounded-sm animate-pulse" />
                    <div className="h-4 bg-gray-300 rounded animate-pulse w-24" />
                  </div>
                </TableCell>
                <TableCell>
                  <div className="h-4 bg-gray-300 rounded animate-pulse w-20" />
                </TableCell>
                <TableCell>
                  <div className="h-4 bg-gray-300 rounded animate-pulse w-12" />
                </TableCell>
                <TableCell>
                  <div className="h-5 w-20 bg-gray-300 rounded animate-pulse" />
                </TableCell>
                <TableCell>
                  <div className="h-7 w-[150px] bg-gray-300 rounded-full animate-pulse" />
                </TableCell>
                <TableCell>
                  <div className="h-7 w-[150px] bg-gray-300 rounded-full animate-pulse" />
                </TableCell>
                <TableCell>
                  <div className="h-7 w-[150px] bg-gray-300 rounded-full animate-pulse" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export function SkeletonVolumes() {
  return (
    <div className="space-y-4">
      <div className="rounded-md">
        <Table>
          <TableHeader>
            <TableRow className="h-[60px]">
              <TableHead>Month (First to Last day of each month)</TableHead>
              <TableHead className="text-right">TOTAL in USD</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: 6 }).map((_, index) => (
              <React.Fragment key={index}>
                {/* Main row */}
                <TableRow className="hover:bg-gray-50 cursor-pointer h-[60px]">
                  <TableCell className="font-medium flex items-center h-[60px]">
                    <div className="w-4 h-4 bg-gray-300 rounded animate-pulse mr-2" />
                    <div className="h-5 w-32 bg-gray-300 rounded animate-pulse" />
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex items-center justify-end gap-2">
                      <div className="w-3 h-3 bg-gray-300 rounded-full animate-pulse" />
                      <div className="h-5 w-20 bg-gray-300 rounded animate-pulse" />
                      <div className="h-4 w-8 bg-gray-300 rounded animate-pulse" />
                    </div>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export function SkeletonBoxes() {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <Card key={index} className="flex flex-col h-full">
          <CardHeader>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2.5">
                {/* Group image skeleton */}
                <div className="w-10 h-10 bg-gray-300 rounded-lg animate-pulse" />
                {/* Group name skeleton */}
                <div className="h-8 w-24 bg-gray-300 rounded animate-pulse" />
              </div>
              {/* Status badge skeleton */}
              <div className="h-5 w-16 bg-gray-300 rounded animate-pulse" />
            </div>
          </CardHeader>

          <CardContent className="space-y-4 flex-1">
            <div className="grid grid-cols-2 gap-2">
              {/* Group Owners section */}
              <div className="space-y-2">
                <div className="h-3 w-20 bg-gray-300 rounded animate-pulse" />
                <div className="flex flex-col gap-2">
                  <div className="h-4 w-16 bg-gray-300 rounded animate-pulse" />
                  <div className="h-4 w-20 bg-gray-300 rounded animate-pulse" />
                </div>
              </div>

              {/* Active Companies section */}
              <div className="space-y-2 pl-3">
                <div className="h-3 w-24 bg-gray-300 rounded animate-pulse" />
                <div className="h-4 w-8 bg-gray-300 rounded animate-pulse" />
              </div>
            </div>

            {/* ID section */}
            <div className="space-y-2">
              <div className="h-3 w-8 bg-gray-300 rounded animate-pulse" />
              <div className="flex items-center gap-2">
                <div className="h-4 w-20 bg-gray-300 rounded animate-pulse" />
                <div className="h-6 w-20 bg-gray-300 rounded animate-pulse" />
              </div>
            </div>
          </CardContent>

          <CardFooter>
            <div className="flex gap-2 w-full">
              <div className="h-9 flex-1 bg-gray-300 rounded animate-pulse" />
              <div className="h-9 flex-1 bg-gray-300 rounded animate-pulse" />
            </div>
          </CardFooter>
        </Card>
      ))}
    </div>
  )
}

export function SkeletonCards() {
  return (
    <div className="space-y-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <Card key={index} className="border-0 shadow-sm py-0">
          <CardContent className="flex items-center justify-between p-6 w-full">
            <div className="flex items-center gap-4 w-full">
              <div className="flex flex-col gap-4 w-full">
                <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
                  <div className="flex items-center gap-4">
                    {/* Avatar skeleton */}
                    <div className="h-12 w-12 bg-gray-300 rounded-sm animate-pulse" />

                    {/* Username and badges skeleton */}
                    <div className="flex flex-col justify-center w-[200px]">
                      <div className="h-6 bg-gray-300 rounded animate-pulse mb-2" />
                      <div className="flex items-center gap-2">
                        <div className="h-5 w-20 bg-gray-300 rounded animate-pulse" />
                        <div className="h-5 w-24 bg-gray-300 rounded animate-pulse" />
                      </div>
                    </div>
                  </div>

                  {/* Stats skeleton */}
                  <div className="flex gap-8">
                    <div className="flex items-center gap-2 md:block">
                      <div className="h-4 w-24 bg-gray-300 rounded animate-pulse mb-1" />
                      <div className="h-6 w-8 bg-gray-300 rounded animate-pulse" />
                    </div>
                    <div className="flex items-center gap-2 md:block">
                      <div className="h-4 w-20 bg-gray-300 rounded animate-pulse mb-1" />
                      <div className="h-6 w-8 bg-gray-300 rounded animate-pulse" />
                    </div>
                  </div>
                </div>

                <div className="flex justify-between md:flex-row flex-col gap-4 md:gap-0">
                  {/* Email and last active skeleton */}
                  <div className="flex flex-col">
                    <div className="h-4 w-32 bg-gray-300 rounded animate-pulse mb-1" />
                    <div className="h-3 w-28 bg-gray-300 rounded animate-pulse" />
                  </div>

                  {/* Action buttons skeleton */}
                  <div className="flex flex-col gap-2">
                    <div className="h-9 w-[150px] bg-gray-300 rounded-full animate-pulse" />
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}

export function SkeletonHeader() {
  return (
    <div className="flex items-center gap-3 py-2">
      <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
      <div className="h-8 bg-gray-200 rounded w-32 animate-pulse"></div>
      <div className="h-6 bg-gray-200 rounded w-16 animate-pulse"></div>
      <div className="ml-auto h-8 bg-gray-200 rounded w-20 animate-pulse"></div>
    </div>
  )
}

export function SkeletonPendingActivity() {
  return (
    <Card className="p-4">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center justify-between md:justify-start gap-4 flex-wrap w-full">
          {/* Activity Type Badge Skeleton */}
          <div className="h-7 w-20 bg-gray-300 rounded-full animate-pulse" />

          {/* Transaction Details Skeleton */}
          <div className="flex items-center gap-3 w-full md:w-auto">
            <div className="flex items-center gap-2 md:gap-3 flex-wrap">
              {/* Crypto Icon Skeleton */}
              <div className="w-8 h-8 bg-gray-300 rounded-sm animate-pulse" />

              {/* Amount Skeleton */}
              <div>
                <div className="h-4 w-16 bg-gray-300 rounded animate-pulse mb-1" />
              </div>

              {/* Currency Info Skeleton */}
              <div>
                <div className="h-3 w-8 bg-gray-300 rounded animate-pulse mb-1" />
                <div className="h-3 w-12 bg-gray-300 rounded animate-pulse" />
              </div>
            </div>

            {/* Arrow Skeleton (for trade transactions) */}
            <div className="h-8 w-8 bg-gray-300 rounded-full animate-pulse" />

            {/* Second Currency Skeleton (for trade transactions) */}
            <div className="flex items-center gap-2 md:gap-3 flex-wrap">
              <div className="w-8 h-8 bg-gray-300 rounded-sm animate-pulse" />
              <div>
                <div className="h-4 w-16 bg-gray-300 rounded animate-pulse mb-1" />
              </div>
              <div>
                <div className="h-3 w-8 bg-gray-300 rounded animate-pulse mb-1" />
                <div className="h-3 w-12 bg-gray-300 rounded animate-pulse" />
              </div>
            </div>
          </div>
        </div>

        {/* Status and Date Skeleton */}
        <div className="flex items-center gap-8 flex-wrap md:flex-nowrap w-full md:w-auto justify-end md:justify-start md:shrink-0">
          <div className="flex items-center gap-2">
            {/* Status Badge Skeleton */}
            <div className="h-7 w-24 bg-gray-300 rounded-full animate-pulse" />
            {/* Flagged Badge Skeleton */}
            <div className="h-7 w-16 bg-gray-300 rounded-full animate-pulse" />
          </div>

          {/* Date Skeleton */}
          <div className="flex items-center gap-2 text-xs font-semibold text-right shrink-0">
            <div className="h-3 w-16 bg-gray-300 rounded animate-pulse" />
            <div className="h-4 w-4 bg-gray-300 rounded animate-pulse" />
          </div>
        </div>
      </div>
    </Card>
  )
}

export function SkeletonPendingActivityList({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonPendingActivity key={index} />
      ))}
    </div>
  )
}
